import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
import { SignUpCard } from '../containers'
import { CustomizedSnackbar, Word } from '../../../containers'
import { WID } from '../../../constants/Language';
import { Auth0Context } from '../../../Parts/Auth0';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom'

const styles = theme => ({
  signUpBox: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: 'auto',
    maxWidth: 400,
    maxHeight: 400,
  },
  actionBox: {
    marginTop: theme.spacing.unit,
    display: 'flex',
    justifyContent: 'flex-start',
  },
})

function SignUp(props) {
  const { classes } = props

  const auth0Context = useContext(Auth0Context)

  const history = useHistory()

  const handleBack = () => {
    auth0Context.logout()
    history.goBack()
  }

  return (
    <div className={classes.signUpBox}>
      <SignUpCard/>
      <div className={classes.actionBox}>
        <div>
          <Button variant='text' color='primary' onClick={handleBack}>
            <Word wid={WID.SIGN_UP.LOGOUT_AND_USE_BUTTON}/>
          </Button>
        </div>
      </div>
      <CustomizedSnackbar/>
    </div>
  )
}

export default withStyles(styles)(SignUp)


// WEBPACK FOOTER //
// ./src/Pages/SignUp/components/SignUp.js